import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'
import type { ImportWrapper } from '@/types'

export function getKidsRoutes({ registerImport }: { registerImport: ImportWrapper }): RouteRecordRaw[] {
    return [
        {
            path: '',
            name: ROUTE_NAMES.KIDS,
            component: registerImport(() => import('@/pages/Kids/KidsPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: 'error',
            name: ROUTE_NAMES.KIDS_ERROR,
            component: registerImport(() => import('@/pages/Kids/KidsNotFoundPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true, noIndex: true },
        },
        {
            path: ':catchAll(.*)',
            name: ROUTE_NAMES.KIDS_NOT_FOUND,
            component: registerImport(() => import('@/pages/Kids/KidsNotFoundPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true, noIndex: true },
        },
    ]
}
